var scrollButton = document.querySelector('.scroll-to-top');

function toggleScrollButtonVisibility() {
  if (window.scrollY > 100) {
    scrollButton.classList.add('show--scroll');
  } else {
    scrollButton.classList.remove('show--scroll');
  }
}

window.addEventListener('scroll', toggleScrollButtonVisibility);

if (scrollButton) {
  scrollButton.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
}
